import { useState } from "react";
import { CalendarClock } from "lucide-react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { RenewalForecast } from "./RenewalForecast";

export const IqamaRenewalsButton = ({ onClosed }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="outline" size="sm" className="h-8 gap-1.5 border-indigo-200 text-xs text-indigo-700" data-testid="open-iqama-renewals-button" onClick={() => setOpen(true)}>
        <CalendarClock className="h-3.5 w-3.5" /> تجديد الإقامات
      </Button>
      <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) onClosed?.(); }}>
        <DialogContent dir="rtl" className="max-h-[92vh] overflow-y-auto sm:max-w-3xl" data-testid="iqama-renewals-dialog">
          <DialogHeader className="text-start"><DialogTitle>تجديد الإقامات وكروت العمل</DialogTitle></DialogHeader>
          {open && <RenewalForecast initialMonth="overdue" />}
        </DialogContent>
      </Dialog>
    </>
  );
};
